import { FETCH_TRANSPORTER_SHARE_TRACK, RECEIVE_TRANSPORTER_SHARE_TRACK, FAILED_TRANSPORTER_SHARE_TRACK } from '../actions/aTransporter-ShareTracker'

const defaultTransporterShareTrackState = {
    transporterShareTrackData: []    
}

export function fetchTransporterShareTrack(state = defaultTransporterShareTrackState, action){
    switch (action.type) {
        case FETCH_TRANSPORTER_SHARE_TRACK:
            return ({transporterShareTrackData: [], inProgress: true})
        case RECEIVE_TRANSPORTER_SHARE_TRACK:
            return Object.assign({}, state, {transporterShareTrackData: action.payload, inProgress: false})
        case FAILED_TRANSPORTER_SHARE_TRACK:
            return ({transporterShareTrackData: [], inProgress: false})
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/redTransporter-ShareTracker.jsx